import { ChevronDown } from "lucide-react";
import type { ID } from "common/utils/models";

type Variant = {
  id: ID;
  size: string;
};

type SampleSizeSelectorProps = {
  compositionId: ID;
  variants: Variant[];
  selectedVariantId: ID | "";
  onSampleSizeChange: (selectedVariantId: ID) => void;
  isOutOfStock: (variantId: ID) => boolean;
};

export function SampleSizeSelector({
  compositionId,
  variants,
  selectedVariantId,
  onSampleSizeChange,
  isOutOfStock
}: SampleSizeSelectorProps) {
  return (
    <div className="flex items-center justify-center gap-4">
      <label
        htmlFor={`size-select-${compositionId}`}
        className="block text-sm font-bold text-gray-800"
        data-testid="size-select-label"
      >
        Select Size
      </label>
      <div className="relative">
        <select
          className="border-input bg-background block w-full appearance-none rounded-md border-2 px-3 py-2 pr-10 text-base font-medium text-gray-800"
          id={`size-select-${compositionId}`}
          onChange={e => e.target.value && onSampleSizeChange(e.target.value)}
          value={selectedVariantId}
          data-testid="size-select"
        >
          <option disabled value="" data-testid="size-option-placeholder">
            Choose a size
          </option>
          {variants.map(({ id, size: variantSize }) => {
            const outOfStock = isOutOfStock(id);
            return (
              <option key={id} value={id} disabled={outOfStock} data-testid="size-option">
                {variantSize} {outOfStock ? "(Out of Stock)" : ""}
              </option>
            );
          })}
        </select>
        <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-800" />
      </div>
    </div>
  );
}
